import { Component, Input } from '@angular/core';
import { PatientAttachment } from 'app/core/models/patient-attachment.model';


@Component({
    selector: 'app-patient-attachment-duplicate',
    templateUrl: './patient-attachment-duplicate.component.html',
    styleUrl: './patient-attachment-duplicate.component.scss',
    imports: []
})
export class PatientAttachmentDuplicateComponent {
  @Input() patientAttachment: PatientAttachment;
}
